import Stack from '@mui/material/Stack'
import { useAuthStore } from 'auth/AuthStore'
import AuthCardWrapper from 'auth/shared/AuthCardWrapper'
import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import CenterFullScreen from 'reusable/mui/utilities/CenterFullScreen'
import useQuery from 'reusable/hooks/useQuery'
import AuthMessage from 'auth/shared/AuthMessage'
import AuthNonAdvisorSignUpStore from './AuthNonAdvisorSignUpStore'
import useInitialMount from 'reusable/hooks/useInitialMount'
import AuthSignupTerms from '../AuthSignupTerms'
import AuthVerification from 'auth/verification/AuthVerification'
import Typography from '@mui/material/Typography'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import TextFieldPassword from 'reusable/mui/text-field-password/TextFieldPassword'
import onEnterProp from 'reusable/utils/on-enter-prop'

export default observer(function AuthNonAdvisorSignUp() {
   const authStore = useAuthStore()
   const queryString = useQuery()
   const postJoinUrl = queryString.get('postJoinUrl') || undefined

   if (postJoinUrl) {
      authStore.afterSucessFullVerification = () => {
         authStore.sp.regionRouterStore.navigate(postJoinUrl)
      }
   }

   const authNonAdvisorSignUpStore = useStore(() => new AuthNonAdvisorSignUpStore({ authStore, postJoinUrl }))

   useInitialMount(async () => {
      await authNonAdvisorSignUpStore.fetchUser()
      await authNonAdvisorSignUpStore.ensureInviteIsPendingAcceptance()
   })

   if (authNonAdvisorSignUpStore.verifyingEmailAttribute) {
      return <AuthVerification
         method="email"
         email={authStore.fields.email}
         customHandlers={{
            verifyCode: authNonAdvisorSignUpStore.verifyEmailAttribute,
            resendCode: authNonAdvisorSignUpStore.resendEmailAttributeCode,
            backToLogin: authNonAdvisorSignUpStore.backToLogin,
         }}
      />
   }

   return <CenterFullScreen>
      <Stack sx={{ mx: 1 }}>
         <AuthMessage message="You've been invited to join the team. Please set your password to get started." sx={{
            maxWidth: '564px',
            mx: 'auto',
            mb: 3,
         }} />
      </Stack>
      <AuthCardWrapper title="Sign up">
         <Stack spacing={3}>
            <Typography sx={{ textAlign: 'center' }}>
               {authStore.fields.email}
            </Typography>
            {authNonAdvisorSignUpStore.formHandler.password.bindInput(ip =>
               <TextFieldPassword
                  fullWidth
                  label="Password"
                  {...onEnterProp(authNonAdvisorSignUpStore.signUp)}
                  {...ip}
               />)}
            {authNonAdvisorSignUpStore.formHandler.passwordConfirm.bindInput(ip =>
               <TextFieldPassword
                  fullWidth
                  label="Confirm Password"
                  skipValidation
                  {...onEnterProp(authNonAdvisorSignUpStore.signUp)}
                  {...ip}
               />)}
            <ButtonWithProgress
               loading={authNonAdvisorSignUpStore.loader.isLoading}
               disabled={!authNonAdvisorSignUpStore.user?.email}
               variant="contained"
               onClick={authNonAdvisorSignUpStore.signUp}>
               Sign Up
            </ButtonWithProgress>
         </Stack>
         <AuthSignupTerms isRegisterAction={true} />
      </AuthCardWrapper>
   </CenterFullScreen>
})
